import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { ForecastCoordinatorUpdateDTOConverter, jsonConversions, TreeInfoDTOConverter, Utils, WindowActionContextConverter, WindowConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
import { GenericTransportLayer } from '../GenericTransportLayer';
export var ForecastCoordinatorLayer =
/*#__PURE__*/
function (_GenericTransportLaye) {
  _inherits(ForecastCoordinatorLayer, _GenericTransportLaye);

  function ForecastCoordinatorLayer() {
    _classCallCheck(this, ForecastCoordinatorLayer);

    return _possibleConstructorReturn(this, _getPrototypeOf(ForecastCoordinatorLayer).call(this, CONSTANTS.API.ENDPOINTS.FORECAST_COORDINATOR));
  }

  _createClass(ForecastCoordinatorLayer, [{
    key: "getTreeData",
    value: function getTreeData(filter) {
      var _this = this;

      return api(CONSTANTS.API.ENDPOINTS.FORECAST_COORDINATOR_TREE).post(filter, {
        responseType: 'json'
      }).then(function (response) {
        return (response.data.result || []).map(function (item) {
          return _this.treeInfoDTOConverter.toObject(item, jsonConversions);
        });
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateEntities",
    value: function updateEntities(updateDTOs) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.FORECAST_COORDINATOR_UPDATE).post({
        updates: updateDTOs.map(function (u) {
          return _this2.forecastCoordinatorUpdateDTOConverter.toDocument(u, jsonConversions);
        })
      }, {
        responseType: 'json'
      }).then(function (response) {
        if (response.data && response.data.result) {
          return response.data.result.map(function (item) {
            return _this2.treeInfoDTOConverter.toObject(item, jsonConversions);
          });
        }
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "approveWindows",
    value: function approveWindows(actions) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var perChunk;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                perChunk = 30; // actions per chunk

                _context2.next = 3;
                return Utils.doInBatchesNoResult(actions, perChunk, function (chunk) {
                  return __awaiter(_this3, void 0, void 0,
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee() {
                    var _this4 = this;

                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return api(CONSTANTS.API.ENDPOINTS.FORECAST_COORDINATOR_APPROVE_WINDOWS).post(chunk.map(function (a) {
                              return _this4.windowActionContextConverter.toDocument(a, jsonConversions);
                            }), {
                              responseType: 'json'
                            });

                          case 2:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    }
  }, {
    key: "approveWindowItems",
    value: function approveWindowItems(windowItemIds) {
      return api(CONSTANTS.API.ENDPOINTS.FORECAST_COORDINATOR_APPROVE_WINDOW_ITEMS).post({
        windowItemIds: windowItemIds.toArray()
      }, {
        responseType: 'json'
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getConverter",
    value: function getConverter() {
      return this.treeInfoDTOConverter;
    }
  }]);

  return ForecastCoordinatorLayer;
}(GenericTransportLayer);

__decorate([Inject, __metadata("design:type", TreeInfoDTOConverter)], ForecastCoordinatorLayer.prototype, "treeInfoDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", ForecastCoordinatorUpdateDTOConverter)], ForecastCoordinatorLayer.prototype, "forecastCoordinatorUpdateDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowConverter)], ForecastCoordinatorLayer.prototype, "windowConverter", void 0);

__decorate([Inject, __metadata("design:type", WindowActionContextConverter)], ForecastCoordinatorLayer.prototype, "windowActionContextConverter", void 0);